/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {makePersistent} from '@app/lib/MobXPersistence';
import {makeAutoObservable} from 'mobx';

class WhatsNewStore {
	lastDismissedEntryId: string | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void this.initPersistence();
	}

	private async initPersistence(): Promise<void> {
		await makePersistent(this, 'WhatsNewStore', ['lastDismissedEntryId']);
	}

	shouldShow(entryId: string, entryDate: Date, userCreatedAt: Date): boolean {
		if (this.lastDismissedEntryId === entryId) return false;
		if (entryDate <= userCreatedAt) return false;
		return true;
	}

	dismiss(entryId: string): void {
		this.lastDismissedEntryId = entryId;
	}
}

export default new WhatsNewStore();
